export const ConfirmPrintingResultType = {
    OK: "ok",
    Cancel: "cancel",
    Retry: "retry",
} as const;
export type ConfirmPrintingResultType = typeof ConfirmPrintingResultType[keyof typeof ConfirmPrintingResultType]
